var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5868_9428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1403 16.6328H10.3691C9.61404 16.6328 9.00195 17.2449 9.00195 18C9.00195 18.7551 9.61404 19.3672 10.3691 19.3672H34.1403C34.8954 19.3672 35.5075 18.7551 35.5075 18C35.5075 17.2449 34.8954 16.6328 34.1403 16.6328Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1403 6.37891H10.3691C9.61404 6.37891 9.00195 6.991 9.00195 7.74609C9.00195 8.50119 9.61404 9.11328 10.3691 9.11328H34.1403C34.8954 9.11328 35.5075 8.50119 35.5075 7.74609C35.5075 6.991 34.8954 6.37891 34.1403 6.37891Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1403 26.8867H10.3691C9.61404 26.8867 9.00195 27.4988 9.00195 28.2539C9.00195 29.009 9.61404 29.6211 10.3691 29.6211H34.1403C34.8954 29.6211 35.5075 29.009 35.5075 28.2539C35.5075 27.4988 34.8954 26.8867 34.1403 26.8867Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3457 9.5918C3.36506 9.5918 4.19141 8.76545 4.19141 7.74609C4.19141 6.72674 3.36506 5.90039 2.3457 5.90039C1.32635 5.90039 0.5 6.72674 0.5 7.74609C0.5 8.76545 1.32635 9.5918 2.3457 9.5918Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3457 19.8457C3.36506 19.8457 4.19141 19.0194 4.19141 18C4.19141 16.9806 3.36506 16.1543 2.3457 16.1543C1.32635 16.1543 0.5 16.9806 0.5 18C0.5 19.0194 1.32635 19.8457 2.3457 19.8457Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3457 30.0996C3.36506 30.0996 4.19141 29.2733 4.19141 28.2539C4.19141 27.2346 3.36506 26.4082 2.3457 26.4082C1.32635 26.4082 0.5 27.2346 0.5 28.2539C0.5 29.2733 1.32635 30.0996 2.3457 30.0996Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5868_9428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIconBlue);
export default __webpack_public_path__ + "static/media/list_icon_blue.9915a150dd053525e9ecf3b73895281e.svg";
export { ForwardRef as ReactComponent };